// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7e46734f","239":"504feb39","453":"ed133b1b","455":"31f7151d","977":"171b0d3a"}[chunkId] + ".chunk.js";
};